import { Bound } from "lib/@components/binding/Bound"
import { register } from "lib/routes/register"
import AuthGuard from "minimals-template/components/guards/AuthGuard"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { SystemAdminHeaderBarRight, SystemAdminAppLayout } from "./@layouts/system-admin-app-layout"
import { Box } from "@mui/material"
import { SettingsButtonPortal } from "minimals-template/components/settings/drawer"
import AccountPopover from "routes/@layouts/app/header/AccountPopover"
import { NotOnMobile } from "lib/@components/mobile"
import Logo from "minimals-template/components/Logo"
import { Redirect } from "lib/@components/redirect"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { AuthenticatedApplicationSwitcher, DebugButton } from "plugins/navigation/home/home.runtime"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_SIDE_NAV_REDESIGN } from "routes/@layouts/app/navbar/feature-flag-side-nav-redesign.runtime"

export const systemAdminRoute = (window.SystemAdminRoute = register("/system-admin", <SystemAdminApp />))
systemAdminRoute.register("", <Redirect to="/system-admin/settings" />)

// Top-of-menu link back to the main Facilities-iQ application
registerConditionalPageNavigation(() => true, "/app", "Home", "material-symbols:home-rounded", {
    apps: ["system-admin"],
    priority: 0,
})

SystemAdminHeaderBarRight.plug(<DebugButton priority={-1000} />)
SystemAdminHeaderBarRight.plug(<AuthenticatedApplicationSwitcher if={notRedesignedNav} />)
SystemAdminHeaderBarRight.plug(<SettingsButtonPortal priority={50} $lazy />)

SystemAdminHeaderBarRight.plug(
    <Box pl={1} priority={10000}>
        <AccountPopover menuOptions={[{ label: "Home", linkTo: "/app" }]} $lazy />
    </Box>
)
SystemAdminHeaderBarRight.plug(
    <NotOnMobile priority={30000}>
        <Logo $lazy />
    </NotOnMobile>
)

function SystemAdminApp() {
    return (
        <Bound dontNeedLicense>
            <AuthGuard>
                <DemandGuard demands={["admin"]}>
                    <SystemAdminAppLayout />
                </DemandGuard>
            </AuthGuard>
        </Bound>
    )
}

function notRedesignedNav() {
    return !isEnabled(FEATURE_FLAG_SIDE_NAV_REDESIGN)
}
